import { Component } from "@angular/core";
import { SessionService } from "../../services/session.service";

@Component({
  selector: "app-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
})
export class ToolbarComponent {
  constructor(public sessionService: SessionService) {}
}
